import { Link } from 'react-router-dom';
import { styled } from '@mui/material';

export const sxStyles = {
  subtitle: {
    marginTop: '1rem',
  },
};

export const StyledEmptyStateText = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '768px',
  width: '100%',
  minHeight: '250px',
  textAlign: 'center',
  padding: '0 1.25rem',
  margin: '0 auto',

  '& > div:first-of-type': {
    marginBottom: '3rem',
  },

  [theme.breakpoints.up('sm')]: {
    minHeight: '400px',
  },
}));

export const StyledNavigateLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '2rem',
  maxWidth: '206px',
  width: '100%',
  fontWeight: 600,
  borderRadius: '2px',
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  padding: '0.5rem',
  transition: 'background-color 0.5s',

  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));
